var $ = jQuery = require('jquery');
angular.module('blc').controller('CarsListCtrl', CarsListCtrl);
CarsListCtrl.$inject = ['$scope', 'quote'];
function CarsListCtrl($scope, quote) {
  $scope.quote=quote;
  $('.carlist').on('click', '.check', function(e) {
    var li = $(this).closest('li')
    var car = {
      id: li.data('car-name'),
      listing_image: { image: li.find('img').attr('src') },
      price: li.data('car-price'),
      title: li.find('h3').text()
    }
  $scope.$apply(function($scope) {
    $scope.quote.car = car;
    $scope.quote.popupcar = true;
    // quote.update();
    if(isMobile()){
      show_quote_form();
    } else {
      scroll_to_search_form(function() {
        //         $('.search-block > button').trigger('click');
      })
    }
  })
  });
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/cars_list_ctrl.js
 ** module id = 26
 ** module chunks = 0
 **/